import { AddressDto } from "../address/address.dto";
import { YandexAddressDto } from "../address/yandex-address.dto";
import { ContragentCustomerObjectDto } from "./contragent-customer-object-dto";

export class ContragentWithContactDto {
    public id: number;
	public name: string;
	public legalName: string;
	public shortName: string;
	public inn: string;
	public address: string;
	public addressDescription: string;
	public accountingInfo: string;
	public contactFullName: string;
	public contactFirstName: string;
	public contactMiddleName: string;
	public contactLastName: string;
	public contactPhone: string;
	public contactEmail: string;
	public isIndividual: boolean;
	public contragentTypeId: number;
	public contragnetTypeName: string;
	public paymentTypeId: number;
	public paymentTypeName: string;
	public contragentProjectId: number;
	public kpp: string;
	public ogrn: string;
	public ceoName: string;

	public addressInfo: AddressDto;
	public customerObjects: ContragentCustomerObjectDto[] = [];

	public yandexModel: YandexAddressDto;

	public ignoreAddressCheck: boolean = false;

	/** Лид, из которого создан/привязан клиент. */
	public sourceLeadId: number | null;
	/** UTM-метки лида-источника. */
	public sourceLeadUtmTag: string | null;
}